import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/App.css"; // Import App.css globally
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { WebSocketProvider } from "./components/WebSocketContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WebSocketProvider>
      <App />
    </WebSocketProvider>
  </React.StrictMode>
);

reportWebVitals();